import React, { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import routers from "routes/routes";

export const MainLayout = (props) => {
  const location = useLocation();
  const path = location.pathname;

  const history = useHistory();

  useEffect(() => {
    const found = routers.some((route) =>
      route.childrens?.some(
        (child) => child.path === "/" + path.split("/")[path.split("/").length - 1]
      )
    );

    if (!found && path !== "/dashboard") {
      history.push("/error/page-not-found");
    }
  }, [path, history]);
  return (
    <div className="authLayout hideScrollbar">
      {/* <Navbar /> */}
      <div className="row">
        {/* <div className="col-3">
          <Sidebar />
        </div> */}
        <div className="col-12">{props.children}</div>
      </div>
    </div>
  );
};
